import routes from 'js/core_pre_webpack/routes';

const feature = 'BULK_DOWNLOAD';
const trigger = 'bulk-download-onsite-ping';

export const checkoutUrl = (workId: number) =>
  routes.checkout_url({
    feature,
    trigger,
    work_id: workId,
    upgrade_redirect: encodeURIComponent(
      routes.show_work_url({ id: workId, bulkDownload: true }),
    ),
  });
